import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getItemHistory,
  ITEM_HISTORY_STORAGE_QUERY_KEY,
  type ItemHistoryItem,
  setItemHistory,
} from './utils';

const useAddItemHistory = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (item: ItemHistoryItem) => {
      const prev = getItemHistory();
      const filtered = prev.filter((x) => x.id !== item.id);

      const updated = [item, ...filtered].slice(0, 10);
      setItemHistory(updated);
      return updated;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ITEM_HISTORY_STORAGE_QUERY_KEY,
      });
    },
  });

  return mutation;
};

export default useAddItemHistory;
